"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _default = (0, _core.withStyles)(function (props) {
  return {
    paper: {
      margin: 0,
      '& .MuiAutocomplete-option': {
        color: props.palette.grey[800]
      },
      '& .MuiAutocomplete-noOptions': {
        padding: 0
      }
    }
  };
});

exports["default"] = _default;